import React, { useRef, useState, useCallback, useEffect } from 'react';
import Figure from "react-bootstrap/Figure";
import { MatchEvents } from '../../models/enums/MatchEvents';
import { ClipState } from '../../models/enums/ClipState';
import { faCrosshairs, faFlagCheckered, faXmark  } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ScoringInputType } from '../../models/enums/ScoringInputType';



const PitchView = (props) => {

    const { onRealMarkerXChange, onRealMarkerYChange, isHomeTeamLeft, startReason, endReason, clipState, startTeamId, endTeamId, homeTeamId, previousClipYCoordinate, selectedPlayer, previousCoordinates, clipSelected, firstCurrentAtOrigin, secondCurrentAtOrigin, firstHalfStart, secondHalfStart } = props;

    const pitchView = useRef(null);

    const [pitchMarkerY, setPitchMarkerY] = useState(-1);
    const [pitchMarkerX, setPitchMarkerX] = useState(-1);
    const [realMarkerX, setRealMarkerX] = useState(0);
    const [realMarkerY, setRealMarkerY] = useState(0);
    const [isEdit, setIsEdit] = useState(true);

    const offSetPercentageX = 14;
    const offSetPercentageY = 4;
    const offsetTop = pitchView.current ? pitchView.current.offsetTop : 24;
    const offsetLeft = pitchView.current ? pitchView.current.offsetLeft : 43;
    const clientWidth = pitchView.current ? pitchView.current.clientWidth : 449;
    const clientHeight = pitchView.current ? pitchView.current.clientHeight : 245;
    const actualOffsetX = (clientWidth / 100) * offSetPercentageX;
    const actualOffsetY = (clientHeight / 100) * offSetPercentageY;
    const selectedClipState =  clipSelected?.type === ScoringInputType.ClipStart ? ClipState.StartClipAndSelectPosition : clipSelected?.type ? ClipState.EndClipAndSelectPosition : clipState;

    const xCoordinate = (isEdit && clipSelected?.positionX) ? Math.round(clipSelected?.positionX) : (isEdit && selectedPlayer?.positionX) ? Math.round(selectedPlayer?.positionX) : Math.round(realMarkerX);

    const yCoordinate = (isEdit && clipSelected?.positionY) ? Math.round(clipSelected?.positionY) : (isEdit && selectedPlayer?.positionY) ? Math.round(selectedPlayer?.positionY) : Math.round(realMarkerY);

    const playerMarkerPositionX = (x, clientWidth, pitchOffsetX, actualOffsetX) => {

        let pitchViewWidthX = clientWidth - (2 * actualOffsetX);
        let scaleX = 100 / pitchViewWidthX;
        let withinPitchViewX = x / scaleX;
        let positionX = withinPitchViewX + actualOffsetX + pitchOffsetX;
        
        return positionX - 6;
    }

    const playerMarkerPositionY = (y, clientHeight, pitchOffsetY, actualOffsetY) => {

        let pitchViewHeightY = clientHeight - (2 * actualOffsetY) - (pitchOffsetY / 2)
        let scaleY = 70.0 / pitchViewHeightY;
        let withinPitchViewY =  (70 - y) / scaleY;
        let positionY = withinPitchViewY + actualOffsetY + pitchOffsetY;
        return  positionY - 7.5
    }

    const findRealMarkerPositionX = (x, clientWidth, pitchOffsetX, actualOffsetX) => {
        let withinPitchViewX = x - actualOffsetX - pitchOffsetX;
        let pitchViewWidthX = clientWidth - (2 * actualOffsetX);
        let scaleX = 100 / pitchViewWidthX;
        let positionScaledX = scaleX * withinPitchViewX;

        if (positionScaledX < 0) positionScaledX = 0;
        if (positionScaledX > 100) positionScaledX = 100;
        
        return positionScaledX;
    }

    const findRealMarkerPositionY = (y, clientHeight, pitchOffsetY, actualOffsetY) => {
        let withinPitchViewY = y - actualOffsetY - pitchOffsetY;
        let pitchViewHeightY = clientHeight - (2 * actualOffsetY) - (pitchOffsetY / 2)
        let scaleY = 70.0 / pitchViewHeightY;
        let positionScaledY = scaleY * withinPitchViewY;

        if (positionScaledY < 0) positionScaledY = 0;
        if (positionScaledY > 70) positionScaledY = 70;

        return Math.abs(70 - positionScaledY);
    }

    const setPitchMarkerPositionX = (pos, clientWidth, pitchOffsetX, actualOffsetX) => {
        let percentageX = pos / 100.0;
        let pitchViewWidthX = clientWidth - 2 * (actualOffsetX - 1);
        let withinPitchViewX = pitchViewWidthX * percentageX + pitchOffsetX + actualOffsetX;
        setRealMarkerX(pos);
        setPitchMarkerX(withinPitchViewX - 16);
    }

    const setPitchMarkerPositionY = (pos, clientHeight, pitchOffsetY, actualOffsetY ) => {
        let percentageY = (70 - pos) / 70.0;
        let pitchViewHeightY = clientHeight - 2 * (actualOffsetY + 2);
        let withinPitchViewY = pitchViewHeightY * percentageY + actualOffsetY + (pitchOffsetY / 2.0);

        setRealMarkerY(pos);
        setPitchMarkerY(withinPitchViewY);
    }

    let correctMarkerX = (realMarkerXPos, startReason, endReason, clientWidth, offsetLeft, actualOffsetX, selectedClipTeamId, half) => {
        let teamId = selectedClipTeamId || (selectedClipState == ClipState.StartClipAndSelectPosition ? startTeamId : endTeamId);
        let isAttackingRight = teamId == homeTeamId ? isHomeTeamLeft : !isHomeTeamLeft;
        let isFirstOrSecondAtOrigin = selectedClipTeamId && half == 2 ? secondCurrentAtOrigin == selectedClipTeamId : (selectedClipTeamId ? firstCurrentAtOrigin == selectedClipTeamId : null);
        let isEditClip = (isHomeTeamLeft !== null && Object.keys(clipSelected).length === 0) ? isAttackingRight : isFirstOrSecondAtOrigin;
        if (selectedClipState == ClipState.StartClipAndSelectPosition) {
            switch (startReason) {
                case MatchEvents.Lineout:
                case MatchEvents.QuickLineout:
                case MatchEvents.ThreeManLineout:
                case MatchEvents.FourManLineout:
                case MatchEvents.FiveManLineout:
                case MatchEvents.SixManLineout:
                case MatchEvents.SevenManLineout:
                    if (realMarkerXPos < 5) {
                        realMarkerXPos = 5;                    
                    } else if (realMarkerXPos > 95) {
                        realMarkerXPos = 95; 
                    }
                    break;
                case MatchEvents.Scrum:
                    if (realMarkerXPos < 5) {
                        realMarkerXPos = 5; 
                    } else if (realMarkerXPos > 95) {
                        realMarkerXPos = 95;
                    } 
                    break;
                case MatchEvents.TwentyTwo:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos != 22 ?  22 : realMarkerXPos 
                    } else {
                        realMarkerXPos = realMarkerXPos != 78 ? 78 : realMarkerXPos 
                    }
                    break;
                case MatchEvents.GoalLineDropOut:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos > 0 ? 0 : realMarkerXPos
                    } else {
                        realMarkerXPos = realMarkerXPos < 100 ? 100 : realMarkerXPos
                    }
                    break;
                default:
                    break;
            }
        } else {
            switch (endReason) {
                case MatchEvents.Lineout:
                case MatchEvents.QuickLineout:
                case MatchEvents.ThreeManLineout:
                case MatchEvents.FourManLineout:
                case MatchEvents.FiveManLineout:
                case MatchEvents.SixManLineout:
                case MatchEvents.SevenManLineout:
                    if (realMarkerXPos < 5) {
                        realMarkerXPos = 5;                    
                    } else if (realMarkerXPos > 95) {
                        realMarkerXPos = 95; 
                    }
                    break;
                case MatchEvents.Try:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos < 100 ? 100 : realMarkerXPos
                    } else {
                        realMarkerXPos = realMarkerXPos > 0 ? 0 : realMarkerXPos
                    }
                    break;
                case MatchEvents.Scrum:
                    if (realMarkerXPos < 5) {
                        realMarkerXPos = 5; 
                    } else if (realMarkerXPos > 95) {
                        realMarkerXPos = 95;
                    } 
                    break;
                case MatchEvents.TwentyTwo:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos != 22 ?  22 : realMarkerXPos 
                    } else {
                        realMarkerXPos = realMarkerXPos != 78 ? 78 : realMarkerXPos 
                    }
                    break;
                case MatchEvents.GoalLineDropOut:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos > 0 ? 0 : realMarkerXPos
                    } else {
                        realMarkerXPos = realMarkerXPos < 100 ? 100 : realMarkerXPos
                    }
                    break;
                case MatchEvents.PenaltyTry:
                    if (isEditClip == true) {
                        realMarkerXPos = realMarkerXPos < 100 ? 100 : realMarkerXPos
                    } else {
                        realMarkerXPos = realMarkerXPos > 0 ? 0 : realMarkerXPos
                    }
                    break;
                default:
                    break;
            }
        }
        
        setPitchMarkerPositionX(realMarkerXPos, clientWidth, offsetLeft, actualOffsetX)
        return realMarkerXPos;
    }

    let correctMarkerY = (realMarkerYPos, startReason, endReason, clientHeight, offsetTop, actualOffsetY) => {
    if (selectedClipState == ClipState.StartClipAndSelectPosition) {
        switch (startReason) {
            case MatchEvents.Lineout:
                case MatchEvents.QuickLineout:
                case MatchEvents.ThreeManLineout:
                case MatchEvents.FourManLineout:
                case MatchEvents.FiveManLineout:
                case MatchEvents.SixManLineout:
                case MatchEvents.SevenManLineout:
                if (realMarkerYPos >= 35) {
                    realMarkerYPos = 70;
                } else {
                    realMarkerYPos = 0;
                }
                break;
            case MatchEvents.Scrum:
                if (realMarkerYPos > 65) {
                    realMarkerYPos = 65;
                } else if (realMarkerYPos < 5) {
                    realMarkerYPos = 5;
                }
                break;
            case MatchEvents.ShotAtGoalConversion:
                realMarkerYPos = previousClipYCoordinate ? previousClipYCoordinate : realMarkerYPos;
                break;
            default:
                break;
        }
    }else{
        switch (endReason) {
                case MatchEvents.Lineout:
                case MatchEvents.QuickLineout:
                case MatchEvents.ThreeManLineout:
                case MatchEvents.FourManLineout:
                case MatchEvents.FiveManLineout:
                case MatchEvents.SixManLineout:
                case MatchEvents.SevenManLineout:    
                if (realMarkerYPos >= 35) {
                    realMarkerYPos = 70;
                } else {
                    realMarkerYPos = 0;
                }
                break;
            case MatchEvents.Scrum:
                if (realMarkerYPos > 65) {
                    realMarkerYPos = 65;
                } else if (realMarkerYPos < 5) {
                    realMarkerYPos = 5;
                }
                break;
            case MatchEvents.PenaltyTry:
                realMarkerYPos = 35
                break;
            default:
                break;
        }
    }
        setPitchMarkerPositionY(realMarkerYPos, clientHeight, offsetTop, actualOffsetY);
        return realMarkerYPos;
    }

    let targetIcon = pitchMarkerY >= 0 && pitchMarkerX >= 0 ? 
    <div style={{ top: pitchMarkerY + 'px', left: pitchMarkerX + 'px', pointerEvents: "none", position: "absolute" }}>
        <img src="/assets/icons/target.svg" alt="Target location" className="w-8 h-8 z-40" />
    </div> :
    selectedPlayer?.positionX >= 0 && selectedPlayer?.positionY >= 0 ? 
    <div style={{ top: playerMarkerPositionY(selectedPlayer?.positionY, clientHeight, offsetTop, actualOffsetY) + 0.5 + 'px', left: playerMarkerPositionX(selectedPlayer?.positionX, clientWidth, offsetLeft, actualOffsetX) - 9.5 + 'px', pointerEvents: "none", position: "absolute" }}>
        <img src="/assets/icons/target.svg" alt="Target location" className="w-8 h-8 z-40" />
    </div> : clipSelected?.positionX >= 0 && clipSelected?.positionY >= 0 ? 
    <div style={{ top: playerMarkerPositionY(clipSelected?.positionY, clientHeight, offsetTop, actualOffsetY) + 0.5 + 'px', left: playerMarkerPositionX(clipSelected?.positionX, clientWidth, offsetLeft, actualOffsetX) - 9.5 + 'px', pointerEvents: "none", position: "absolute" }}>
    <img src="/assets/icons/target.svg" alt="Target location" className="w-8 h-8 z-40" />
    </div> : <></>;

    let previousIcon = previousCoordinates.positionX === previousCoordinates.clipStartPositionX && previousCoordinates.positionY === previousCoordinates.clipStartPositionY ? <></> : previousCoordinates.positionX >= 0 && previousCoordinates.positionY >= 0 ? <div style={{ top: playerMarkerPositionY(previousCoordinates.positionY, clientHeight, offsetTop, actualOffsetY) + 'px', left: playerMarkerPositionX(previousCoordinates.positionX, clientWidth, offsetLeft, actualOffsetX) + 'px', pointerEvents: "none", position: "absolute" }}>
        <FontAwesomeIcon icon={faXmark} />   
    </div> : <></>;

    let previousClipStartIcon = !previousCoordinates.clipStartPositionX  && !previousCoordinates.clipStartPositionY ? <></> : previousCoordinates.clipStartPositionX >= 0  || previousCoordinates.clipStartPositionY >= 0  ? <div style={{ top: playerMarkerPositionY(previousCoordinates.clipStartPositionY, clientHeight, offsetTop, actualOffsetY) + 'px', left: playerMarkerPositionX(previousCoordinates.clipStartPositionX, clientWidth, offsetLeft, actualOffsetX) + 'px', pointerEvents: "none", position: "absolute" }}>
        <FontAwesomeIcon icon={faFlagCheckered} />
    </div> : <></>;

    return <>
        <div>
            <span>  x: {xCoordinate}m,
                    y: {yCoordinate}m</span>
        </div>
        <div className="d-flex">
            <div style={{ width: '20px' }}>
                <span style={{
                    writingMode: 'vertical-lr',
                    textOrientation: 'mixed',
                    transform: 'scale(-1)'
                }}>
                    {isHomeTeamLeft ? 'Home' : 'Away'}
                </span>
            </div>
            <div style={{
                width: 449,
                height: 245
            }}>

                <Figure
                    ref={pitchView}
                    style={{
                        backgroundImage: `url("/images/a_Rugby_union_pitch.png")`,
                        width: 449,
                        height: 245,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain"
                    }}
                    onClick={async (event) => {
                        let x = event.nativeEvent.layerX;
                        let y = event.nativeEvent.layerY;
                        
                        setPitchMarkerX(x - 16);
                        setPitchMarkerY(y - 16);
                        setIsEdit(false);
                        let clipStartReason = clipSelected?.clipStartReason && clipSelected?.type == ScoringInputType.ClipStart? clipSelected?.clipStartReason : startReason;
                        let clipEndReason = clipSelected?.clipEndReason && clipSelected?.type == ScoringInputType.ClipEnd? clipSelected?.clipEndReason : endReason;
                        let realMarkerXPos = findRealMarkerPositionX(x, clientWidth, offsetLeft, actualOffsetX);
                        let realMarkerYPos = findRealMarkerPositionY(y, clientHeight, offsetTop, actualOffsetY);
                        
                        realMarkerXPos = correctMarkerX(realMarkerXPos, clipStartReason, clipEndReason, clientWidth, offsetLeft, actualOffsetX, clipSelected?.teamId, clipSelected?.half);
                        realMarkerYPos = correctMarkerY(realMarkerYPos, clipStartReason, clipEndReason, clientHeight, offsetTop, actualOffsetY, clipSelected?.teamId);

                        setRealMarkerX(realMarkerXPos);
                        setRealMarkerY(realMarkerYPos);

                        onRealMarkerXChange(realMarkerXPos);
                        onRealMarkerYChange(realMarkerYPos);

                        return;
                    }}>
                    {targetIcon}
                    {previousIcon}
                    {previousClipStartIcon}
                </Figure>
            </div>
            <div>
                <span style={{
                    writingMode: 'vertical-rl',
                    textOrientation: 'mixed'
                }}>
                    {isHomeTeamLeft ? 'Away' : 'Home'}
                </span>
            </div>
        </div>
        <div>
            <span style={{ fontSize: '12px', color: 'gray', marginLeft:'20px', fontWeight:'bold' }}
            >  Key:  {<FontAwesomeIcon icon={faFlagCheckered} />} = Clip start, {<FontAwesomeIcon icon={faXmark} />} = Previous Action, {<FontAwesomeIcon icon={faCrosshairs} />} = Current Selection </span>
        </div>
    </>;
}

export default PitchView;